export function startSpin(element: HTMLElement | string, text: string) {
    const el = typeof element === 'string' ? document.querySelector(element) as HTMLElement : element;
    if (!el) return;
    el.innerHTML = `<i class='fas fa-spinner fa-spin'></i>&nbsp${text}`;
    if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
        el.disabled = true;
    }
}

export function stopSpin(element: HTMLElement | string, text: string) {
    const el = typeof element === 'string' ? document.querySelector(element) as HTMLElement : element;
    if (!el) return;
    el.innerHTML = `${text}`;
    if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
        el.disabled = false;
    }
}
